import * as IoC from 'typescript-ioc';
import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { JobDtoType } from '../../index';
import { IConnectionsDAO } from '../../../../api/connections.dao';

export class GenerateConnectionsBlueprintTriggerJob extends JobConfiguration {
    public readonly type = JobType.GenerateConnectionsBlueprintTrigger;
    public readonly name = 'Connection Creation';
    public readonly description = 'Connection Creation';

    public execute(execParams): Promise<JobDtoType> {
        return IoC.Container.get(IConnectionsDAO).generateConnections(execParams);
    }
}

export default {
    [JobType.GenerateConnectionsBlueprintTrigger]: GenerateConnectionsBlueprintTriggerJob
};
